document.addEventListener("DOMContentLoaded", function () {
  const locale = window.Shopify?.locale || "ja";

  const buttonSettings = {
    en: {
      image:
        "https://cdn.shopify.com/s/files/1/0557/8001/6257/files/emoney-white.png?v=1779260276",
      link: "/apps/elife-point/en",
    },
    ja: {
      image:
        "https://cdn.shopify.com/s/files/1/0557/8001/6257/files/emoney-white.png?v=1779260276",
      link: "/apps/elife-point/ja",
    },
  };

  const settings = buttonSettings[locale] || buttonSettings["ja"];

  const isLoggedIn =
    window.elifeCustomerLoggedIn === true ||
    document.body.classList.contains("customer-logged-in") ||
    document.body.className.includes("customer-logged-in") ||
    !!document.querySelector('a[href*="/account/logout"]');

  const existingButton = document.getElementById("elife-points-btn-wrapper");
  if (existingButton) existingButton.remove();

  if (!isLoggedIn) {
    return;
  }

  const buttonWrapper = document.createElement("div");
  buttonWrapper.id = "elife-points-btn-wrapper";
  buttonWrapper.style.position = "fixed";
  buttonWrapper.style.right = "24px";
  buttonWrapper.style.bottom = "24px";
  buttonWrapper.style.zIndex = "9999";

  const button = document.createElement("a");
  button.href = settings.link;
  button.id = "elife-points-btn";

  const image = document.createElement("img");
  image.src = settings.image;
  image.alt = "eMONEY";
  image.style.width = "86px";
  image.style.height = "auto";
  image.style.display = "block";

  button.appendChild(image);
  buttonWrapper.appendChild(button);
  document.body.appendChild(buttonWrapper);
});